export const SET_FIELD_VALUES = 'SET_FIELD_VALUES';
export const CREATE_FIELD_VALUE = 'CREATE_FIELD_VALUE';
export const EDIT_FIELD_VALUE = 'EDIT_FIELD_VALUE';
export const DELETE_FIELD_VALUE = 'DELETE_FIELD_VALUE';

export const FIELDS_SECTION_COTIZACION_INMOBILIARIA = 'cotizacionInmobiliaria';
export const FIELDS_SECTION_PERFILAMIENTO = 'perfilamiento';
